import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Grid } from 'semantic-ui-react';
import { Description } from './description';


const Footer = ({ positionRelative }) => (
  <FooterWrapper positionRelative={positionRelative}>
    <StyledGrid container centered>
      <Grid.Row columns={4} centered>
        <Grid.Column computer={5} tablet={16} mobile={16}>
          <Description />
        </Grid.Column>
        <Grid.Column computer={4} tablet={16} mobile={16}>
          <CategoryContainer>
            <Category>Products</Category>
            <LinkContainer to='/'>HackHub Event</LinkContainer>
            <LinkWrapper
              href='https://www.hackhub.com/talent' target='_blank' rel='noreferrer'
            >HackHub Talent
            </LinkWrapper>
          </CategoryContainer>
        </Grid.Column>
        <Grid.Column computer={3} tablet={16} mobile={16}>
          <CategoryContainer>
            <Category>Company</Category>
            <LinkWrapper href='https://www.hackhub.com/' target='_blank' rel='noreferrer'>Home</LinkWrapper>
          </CategoryContainer>
        </Grid.Column>
        <Grid.Column computer={4} tablet={16} mobile={16}>
          <CategoryContainer>
            <Category>Contact</Category>
            <LinkWrapper href='mailto:info@hackhub.com' target='_blank' rel='noopener noreferrer'>
              info@hackhub.com
            </LinkWrapper>
            <p>#1200 555 W Hastings St</p>
            <p>Vancouver, BC V6B 4N6</p>
            <div className='row contact-logos'>
              <a href='https://www.linkedin.com/company/hackhub'>
                <img src='/img/icons/linkedin.svg' className='contact-logo' alt='LinkedIn' />
              </a>
              <a href='https://twitter.com/hackhubio/'>
                <img src='/img/icons/twitter.svg' className='contact-logo' alt='Twitter' />
              </a>
              <a href='https://www.facebook.com/hackhubio/'>
                <img src='/img/icons/facebook.svg' className='contact-logo' alt='Facebook' />
              </a>
              <a href='https://www.instagram.com/hackhub.io/'>
                <img src='/img/icons/instagram.svg' className='contact-logo' alt='Instagram' />
              </a>
            </div>
          </CategoryContainer>
        </Grid.Column>
      </Grid.Row>
    </StyledGrid>
    <Copyright>
      Copyright© 2016-2022 Inverse Technology, Inc.
    </Copyright>
  </FooterWrapper>
);


const FooterWrapper = styled.div`
  background: linear-gradient(0deg, #0094fb, #0094fb);
  color: #ffffff;
  min-height: 488px;
  padding-top: 40px;
  position: ${(props) => (props.positionRelative ? 'relative' : 'absolute')};
  bottom: 0;
  width: 100%;

  @media only screen and (max-width: 991px) {
    min-height: 600px;
  }

  @media only screen and (max-width: 768px) {
    min-height: 800px;
  }
  @media only screen and (max-width: 430px) {
    min-height: 850px;
  }
  @media only screen and (max-width: 394px) {
    min-height: 900px;
  }

  p {
    margin: 0;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px;
    letter-spacing: 0em;
  }

.contact-logos {
  margin: 1rem 0;
}

.contact-logo {
  margin-right: 12px;
}
`;

const CategoryContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 1.25rem 0.5rem;
  width: 100%;

  @media only screen and (max-width: 768px) {
    margin: 2rem 0.5rem;
  }
`;

const StyledGrid = styled(Grid)`
  padding: 3rem 0;
  min-height: 400px;
  &&&&&&.ui.grid {
    padding-top: 3rem;
  }
  &&.ui.grid > .row {
    background: transparent;
  }

  @media only screen and (max-width: 768px) {
    min-height: 600px;
  }
`;

const Category = styled.h2`
  font-family: Inter;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 29px;
  letter-spacing: 0.12em;
  text-align: left;
  text-transform: uppercase;
`;

const linkStyles = `
  margin: 0;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: 0em;
  color: #fff;
  text-decoration: underline 2px rgba(255, 255, 255, 0);
  transition: text-decoration-color 300ms;
  display: inline-block;
`;

const LinkWrapper = styled.a`
  && {
    ${linkStyles}
  }
`;

const LinkContainer = styled(Link)`
  && {
    ${linkStyles}
  }
`;


const Copyright = styled.div`
  border-top: 1px solid #ffffff;
  padding: 1rem 0 2rem;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: center;
`;

export default Footer;

Footer.defaultProps = {
  positionRelative: false
};



// WEBPACK FOOTER //
// ./src/components/footer/index.js